import React, {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
  useRef,
  useState,
} from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import Label from './Label'
import UnderMessage from './UnderMessage'
import Wrapper from './Wrapper'
import { PopoveredIcon2 } from '../../PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal
  from '../../../containers/UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'

type inputElement<T extends IFormElementProps> = (
  props: T,
) =>
  | InputHTMLAttributes<T>
  | TextareaHTMLAttributes<T>
  | SelectHTMLAttributes<T>

function FormElement<T extends IFormElementProps>(input: inputElement<T>) {
  function RenderElement(props: T & WithTranslation) {
    const inputRef = useRef()
    const {
      label,
      isHorizontal = false,
      errorMsg = '',
      warningMsg = '',
      isReverse = false,
      name,
      wrapperClick,
      size = 1,
      noSpacing = false,
      width,
      isBoldLabel,
      disableLabelOnFalse,
      disabled = false,
      value,
      noAlign = false,
      labelDisabled = false,
      t,
      smallLabelSize,
      wrapLabel,
      changeFieldValue,
      inputWrapperStyle,
      temporaryValue = false,
      labelAutoWidth = false,
      fireEventOnClick = false,
      wrapperStyle,
      errorOnMax,
      errorStyle,
      maxLength,
      onChange,
      noSpacingVertical,
      labelStyle,
      isCenterLabel,
      labelSpacingHorizontal,
      alignInputCenter = false,
      dummyError = false,
      withPopoverIcon = false,
      isPopoverIconVisible = true,
      enableSideButton = false,
    } = props
    const theme2 = useTheme()
    const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
    const [isModalOpened, setIsModalOpened] = useState(false)
    const [popoverAnchor, setPopoverAnchor] = useState(null)

    const handlePopoverOpen = event => {
      event.preventDefault()
      event.stopPropagation()
      setPopoverAnchor(event.currentTarget)
    }

    const handlePopoverClose = event => {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      setPopoverAnchor(null)
    }

    const click = (e: any = {}) => {
      if (wrapperClick) {
        e.name = name
        wrapperClick(e)
      }
      if (!disabled) {
        onclick(e)
      }
    }

    function onclick(e: React.SyntheticEvent<HTMLElement>) {
      e.stopPropagation()
      if (temporaryValue && changeFieldValue) {
        const formInput = inputRef.current as HTMLInputElement
        changeFieldValue(formInput.value)
        const event = new MouseEvent('click')
        formInput.dispatchEvent(event)
      } else if (fireEventOnClick) {
        const formInput = inputRef.current as HTMLInputElement
        const event = new MouseEvent('click')
        formInput.dispatchEvent(event)

        onChange(event)
      }
    }

    return (
      <Wrapper
        row={isHorizontal}
        column={!isHorizontal}
        alignStart={!noSpacing}
        alignCenter={!noAlign}
        justifyCenter={true}
        maxWidth={width}
        style={wrapperStyle}
        onClick={click}
      >
        {!isReverse && label && (
          <Label
            style={labelStyle}
            labelAutoWidth={labelAutoWidth}
            size={size}
            htmlFor={name}
            isCenterLabel={isCenterLabel}
            horizontal={isHorizontal}
            labelSpacingHorizontal={labelSpacingHorizontal}
            margin={noSpacing}
            bold={isBoldLabel}
            noSpacing={noSpacingVertical}
            disabled={(disableLabelOnFalse && !value) || disabled}
            clickable={fireEventOnClick && !disabled}
            wrapLabel={wrapLabel}
            smallLabelSize={smallLabelSize}
            labelDisabled={labelDisabled}
            alignInputCenter={alignInputCenter}
          >
            {typeof label === 'function' ? label() : label}
            {isPopoverIconVisible && withPopoverIcon && (
              <PopoveredIcon2 />
            )}
          </Label>
        )}

        <Flex
          style={{ position: 'relative', ...inputWrapperStyle }}
          full={!noSpacing}
          column={true}
          alignCenter={alignInputCenter}
          // onClick={e => !disabled ? undefined : withPopoverIcon && isMobile ? setIsModalOpened(true) : handlePopoverOpen(e)}

        >
          {!enableSideButton && withPopoverIcon && (
            <Flex
              onClick={e => !disabled ? undefined : isMobile ? !enableSideButton ? setIsModalOpened(true) : undefined : handlePopoverOpen(e)}
              style={{
                position: 'absolute',
                bottom: 0,
                top: 0,
                left: 0,
                right: enableSideButton ? 30  : 0,
                backgroundColor: 'transparent',
                zIndex: 100,
              }}
            ></Flex>
          )}
          {input({ ...props, inputRef, size })}
          {(((errorMsg || errorMsg === ' ') && typeof errorMsg !== 'boolean') ||
            (errorOnMax && value.length >= maxLength)) && (
            <Flex
              alignCenter={true}
              style={{ marginTop: `${4 * size}px`, ...errorStyle }}
            >
              <UnderMessage
                size={size}
                style={{
                  marginTop: errorMsg === ' ' ? `${11 * size}px` : '0px',
                  visibility: dummyError ? 'hidden' : 'visible',
                }}
                error={true}
              >
                {(typeof errorMsg == 'string' && t(errorMsg)) || errorOnMax}
              </UnderMessage>
            </Flex>
          )}

          {warningMsg && (
            <Flex alignCenter={true} style={{ marginTop: `${4 * size}px` }}>
              <UnderMessage size={size} warning={true}>
                {t(warningMsg)}
              </UnderMessage>
            </Flex>
          )}
        </Flex>

        {isReverse && label && (
          <Label
            size={size}
            horizontal={isHorizontal}
            labelDisabled={labelDisabled}
            margin={noSpacing}
            isCenterLabel={isCenterLabel}
            labelAutoWidth={labelAutoWidth}
            bold={isBoldLabel}
            labelSpacingHorizontal={labelSpacingHorizontal}
            noSpacing={noSpacingVertical}
            alignInputCenter={alignInputCenter}
            style={{
              ...labelStyle,
              ...(changeFieldValue
                ? {
                    cursor: 'pointer',
                  }
                : {}),
            }}
            disabled={(disableLabelOnFalse && !value) || disabled}
            clickable={fireEventOnClick && !disabled}
            wrapLabel={wrapLabel}
          >
            {typeof label === 'function' ? label() : label}
            {isPopoverIconVisible && withPopoverIcon && (
              <PopoveredIcon2 />
            )}
          </Label>
        )}

          <PopoveredIcon2
            withIcon={false}
            anchorEl={popoverAnchor}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          />
        {isMobile && <UpgradePremiumBlockScreenModal
          open={isModalOpened}
          close={() => setIsModalOpened(false)}
        />}
      </Wrapper>
    )
  }

  return withTranslation()(RenderElement)
}

export default FormElement
export type IFormElementProps = IElementStatus &
  IElementActions &
  IElementInput &
  IElementPosition &
  IElementStyles

export interface IElementStatus {
  errorMsg?: string | boolean
  warningMsg?: string
  isValidating?: boolean
}

export interface IElementActions {
  onChange?: (event: any) => void
  onFocus?: (event?: any) => void
  validate?: (value: any) => string | undefined
  onClick?: (event: React.SyntheticEvent) => void
  changeFieldValue?: (value) => void
  onBlur?: (event: any) => void | any
  onBlurCustom?: (event: any) => void | any
  onCalculate?: () => void
  onKeyDown?: any
  wrapperClick?: any
  onRefresh?: () => void
  onAfterIconClick?: () => void
  onMouseDown?: any
}

export interface IElementInput {
  checked?: boolean
  label?: string | React.ReactNode | JSX.Element
  smallLabelSize?: boolean
  isCenterLabel?: boolean
  noSpacingVertical?: boolean
  name?: string
  parse?: any
  placeholder?: string
  required?: boolean
  nullAtDisabled?: boolean
  value?: any
  min?: number
  max?: number
  autocomplete?: string
  disabled?: boolean
  className?: string
  wrapWithTextBefore?: string
  wrapWithTextAfter?: string
  wrapperFull?: boolean
  readonly?: boolean
  alignCurrency?: boolean
  formatDate?: string
  formatHours?: string
  labelDisabled?: boolean
  temporaryValue?: any
  wrapperStyle?: React.CSSProperties
  inputStyle?: React.CSSProperties
  labelStyle?: React.CSSProperties
  fireEventOnClick?: boolean
  normalize?: any
  format?: any
  alignInputCenter?: boolean
  currency?: string
  labelAutoWidth?: boolean
  isSmallReservation?: boolean
  isSideButtonDisabled?: boolean
  disableLabelOnFalse?: boolean
  withPopoverIcon?: boolean
  isPopoverIconVisible?: boolean
  isCalculating?: boolean
  size?: number
  type?: string
  inputWrapperStyle?: any
  maxLength?: number
  wrapLabel?: boolean
  zeroOnUndefinied?: boolean
  anchorRef?: React.MutableRefObject<HTMLDivElement>
  labelSpacingHorizontal?: boolean
  allowNegative?: boolean
  disableFocus?: boolean
  onlyMinutes?: boolean
  disableCounter?: boolean
  enableSideButton?: boolean
  errorOnMax?: string
  disallowZero?: boolean
  dirty?: boolean
  afterIconStyle?: any
  dummyError?: boolean
}

export interface IElementPosition {
  isHorizontal?: boolean
  isSelected?: boolean
  isReverse?: boolean
  isCenterLabel?: boolean
  noSpacing?: boolean
  isBoldLabel?: boolean
  noAlign?: boolean
  alignCenter?: boolean
}

export interface IElementStyles {
  width?: string | number
  style?: React.CSSProperties
  errorStyle?: React.CSSProperties
  withAfterIcon?: JSX.Element
  withBeforeIcon?: JSX.Element
  little?: boolean
}
